<script setup lang="ts">
  import loaderImg from '@tundr/theme-assets/icons/loading-icon.svg';
  import { Illustration } from '../Illustration';
  import type { ProcessLoaderProps } from './ProcessLoader.types';
  import {
    processLoaderClass,
    processLoaderSubtitleClass,
    processLoaderTitleClass,
    progressBarClass,
    progressTrackClass,
  } from './ProcessLoader.css';

  withDefaults(defineProps<ProcessLoaderProps>(), {
    titleAs: 'h2',
  });
</script>

<template>
  <div
    :id="id"
    :data-testid="testId"
    :class="processLoaderClass"
    role="status"
    aria-busy="true"
  >
    <Illustration :src="loaderImg" :width="80" :height="80" />
    <component :is="titleAs" :class="processLoaderTitleClass">
      {{ message }}
    </component>
    <p :class="processLoaderSubtitleClass">{{ subtitle }}</p>
    <div :class="progressTrackClass">
      <div :class="progressBarClass" />
    </div>
  </div>
</template>
